import logo from '../assets/images/iex-white-logo-only-img.svg';
import { ImageFitEnum } from '../types/shell';

export const IFRAME_EXPERIENCE_MOCK_DATA = {
  org_info: {
    logo_url:
      'https://storage.googleapis.com/bluebird-public//org_assets/202401171242280_Samuel_Beckett_Bridge_At_Sunset_Dublin_Ireland__97037639___cropped_.jpeg',
    header_color: '#1b1b1b',
    button_color: '#5f11ea',
    vector_image_url: '',
  },
  sender_info: {
    sender_company_name: 'Imprint Engine',
    sender_first_name: 'SenderName',
    sender_last_name: 'SenderLastName',
    sender_uid: 'IDyPONzDDKNhOjQJOTstD6KQhKD3',
  },
  pick_campaigns: [
    {
      id: 'Sop6rRPccJE3Y7eXcLmA',
      name: 'Mystery Gift 1',
      items: [
        {
          id: 'qOxAqP1M4UNFSeTjiJ2r',
          name: 'Mystery Gift 1',
          quantity: 1,
          count: -1,
          image_url:
            'https://storage.googleapis.com/bluebird-public/product_images/vF7weAcNrFFUSxFpmPhK/202503141025040_1-Box-Product.png',
          customization: {},
          preorder_allowed: true,
        },
      ],
      ds_header_color: '',
      ds_button_color: '',
      ds_shipping_page_title: '',
      ds_shipping_page_body: '',
      ds_msku_page_title: '',
      ds_msku_page_body: '',
      ds_customize_items_page_title: '',
      ds_customize_items_page_body: '',
      ds_company_name: '',
      ds_logo_url: '',
      ds_box_image_url: '',
      disable_handwritten_note_step: false,
    },
    {
      id: 'GVQCgVshYzP3W3QEryG7',
      name: 'Mystery Gift 2',
      items: [
        {
          id: 'x9hLw4n2FKZHW3Vy5m3w',
          name: 'Mystery Gift 2',
          quantity: 1,
          count: -1,
          image_url:
            'https://storage.googleapis.com/bluebird-public/product_images/vF7weAcNrFFUSxFpmPhK/202503141025040_1-Box-Product.png',
          customization: {},
          preorder_allowed: true,
        },
      ],
      ds_header_color: '',
      ds_button_color: '',
      ds_shipping_page_title: '',
      ds_shipping_page_body: '\u003cdiv\u003e[Sender.CompanyName]\u003c/div\u003e',
      ds_msku_page_title: '',
      ds_msku_page_body: '',
      ds_customize_items_page_title: '',
      ds_customize_items_page_body: '',
      ds_company_name: 'Awesome company',
      ds_logo_url: '',
      ds_box_image_url: '',
      disable_handwritten_note_step: false,
    },
    {
      id: '054WlbliFrN0pTRPY1It',
      name: 'Mystery campaign',
      items: [
        {
          id: 'G7GfGgWsnh8NniEJiYaw',
          name: 'IE Sticker - 1.5" round - Purple',
          quantity: 1,
          count: 342,
          image_url:
            'https://storage.googleapis.com/bluebird-public/product_images/vF7weAcNrFFUSxFpmPhK/1695726026167738000_202309202040300_Purplecircle.png',
          customization: {},
          preorder_allowed: false,
        },
        {
          id: 'e1jn7NccVmxR4ajlFXFC',
          name: 'IE Sticker - 1.5" round - White',
          quantity: 1,
          count: 372,
          image_url:
            'https://storage.googleapis.com/bluebird-public/product_images/vF7weAcNrFFUSxFpmPhK/1695726028472090000_202309202040140_WHITECIRCLE.png',
          customization: {},
          preorder_allowed: false,
        },
      ],
      ds_header_color: '',
      ds_button_color: '',
      ds_shipping_page_title: 'Just a Test Title',
      ds_shipping_page_body: '\u003cdiv\u003eHere is your gift, [Receiver.FirstName]!\u003c/div\u003e',
      ds_msku_page_title: '',
      ds_msku_page_body: '',
      ds_customize_items_page_title: '',
      ds_customize_items_page_body: '',
      ds_company_name: '',
      ds_logo_url: 'https://storage.googleapis.com/bluebird-public//org_assets/202602041313550_151089.jpg',
      ds_box_image_url: 'https://storage.googleapis.com/bluebird-public//org_assets/202602041314000_IMG_1687.jpg',
      disable_handwritten_note_step: false,
    },
    {
      id: 'rmG2S9xtMNZgrI2TM19o',
      name: 'Mystery gift 3',
      items: [
        {
          id: 'dYiIv693DhQZjPic9mf6',
          name: 'Bandana Options 1',
          quantity: 1,
          count: 0,
          image_url:
            'https://storage.googleapis.com/bluebird-public/product_images/vF7weAcNrFFUSxFpmPhK/1695725979873744000_202309202001400_Proof_201694_3905_IE717_Black.jpg',
          customization: {},
          preorder_allowed: false,
          sku_options: [
            {
              id: '6CVix2DCCCBzV2LEug9o',
              name: 'Doggie Bandana - Black',
              image_url:
                'https://storage.googleapis.com/bluebird-public/product_images/vF7weAcNrFFUSxFpmPhK/1695725979873744000_202309202001400_Proof_201694_3905_IE717_Black.jpg',
              customization: {},
              preorder_allowed: false,
              count: 1,
            },
            {
              id: 'HiHJsIyth5abBH9my6nT',
              name: 'Doggie Bandana TEST DUO - White',
              image_url:
                'https://storage.googleapis.com/bluebird-public/product_images/vF7weAcNrFFUSxFpmPhK/1695725987750540000_202309202001500_Proof_201694_3905_IE717_White.jpg',
              customization: {},
              preorder_allowed: true,
              count: 17,
            },
          ],
        },
      ],
      ds_header_color: '',
      ds_button_color: '',
      ds_shipping_page_title: '',
      ds_shipping_page_body: '',
      ds_msku_page_title: '',
      ds_msku_page_body: '',
      ds_customize_items_page_title: '',
      ds_customize_items_page_body: '',
      ds_company_name: '',
      ds_logo_url: '',
      ds_box_image_url: '',
      disable_handwritten_note_step: false,
    },
  ],
  inventory_items: null,
  is_digital: false,
  ds_customized_texts: {
    shipping_page_title: '',
    shipping_page_body: '',
    pick_your_gift_title: '',
    pick_your_gift_body: '',
    ds_header_color: '',
    ds_button_color: '',
    ds_msku_page_title: '',
    ds_msku_page_body: '',
    ds_customize_items_page_title: 'step 4',
    ds_customize_items_page_body: '<div>step 4</div>',
    ds_company_name: '',
    ds_logo_url: '',
    ds_box_image_url: '',
  },
  receiver_info: {
    receiver_first_name: '',
    receiver_last_name: '',
    receiver_email: '',
    receiver_phone: '',
    receiver_address1: '',
    receiver_city: '',
    receiver_country: '',
    receiver_zip: '',
  },
  shipping_rules: {
    tax_required_countries: {
      BR: { label: 'CPF Number' },
      CN: { label: 'Resident ID Number' },
      KR: { label: 'PCCC Number' },
      MX: { label: 'RFC Number' },
    },
  },
  experience: {
    background: {
      color: '#fbfbfb',
    },
    header: {
      media: {
        image_url: '',
      },
      app_bar: {
        background_color: '#1a1a2e',
        logo_image_url: logo,
      },
      hero_section: {
        background_color: '#e8f4f8',
        image_url: '',
        image_position: 'center', // cover | contain | center | percents
        image_fit: ImageFitEnum.Contain,
      },
    },
    buttons: {
      action: {
        color: '#2e7d32',
      },
    },
    pages: {
      pick_your_gift: {
        header_text: 'Warm wishes this season',
        body_text:
          'Hope you get time to rest and recharge. Choose something you’ll enjoy — and thank you for a great year. Hope you get time to rest and recharge.Choose something you’ll enjoy — and thank you for a great year.Hope you get time to rest and recharge.Choose something you’ll enjoy — and thank you for a great year.Hope you get time to rest and recharge.Choose something you’ll enjoy — and thank you for a great year.Hope you get time to rest and recharge.Choose something you’ll enjoy — and thank you for a great year.Hope you get time to rest and recharge.Choose something you’ll enjoy — and thank you for a great year.Hope you get time to rest and recharge.Choose something you’ll enjoy — and thank you for a great year.Hope you get time to rest and recharge.Choose something you’ll enjoy — and thank you for a great year.Hope you get time to rest and recharge.Choose something you’ll enjoy — and thank you for a great year.Hope you get time to rest and recharge.Choose something you’ll enjoy — and thank you for a great year.Hope you get time to rest and recharge.Choose something you’ll enjoy — and thank you for a great year.',
        overrides: {},
      },
      pick_your_option: {
        header_text: 'Warm wishes this season',
        body_text:
          'Hope you get time to rest and recharge. Choose something you’ll enjoy — and thank you for a great year.',
        overrides: {},
      },
      shipping_page: {
        header_text: 'Warm wishes this season',
        body_text:
          'Hope you get time to rest and recharge. Choose something you’ll enjoy — and thank you for a great year.',
        overrides: {},
      },
    },
  },
};
